import { useEffect, useState } from 'react';
import useScreenSize from '@/shared/hooks/useScreenSize';

export const useResponsiveLabelSteps = (initialSteps: number) => {
  const { isMobile, isTablet } = useScreenSize();
  const [steps, setSteps] = useState(initialSteps);

  useEffect(() => {
    if (isMobile) setSteps(3);
    else if (isTablet) setSteps(4);
    else setSteps(initialSteps);
  }, [isMobile, isTablet, initialSteps]);

  return steps;
};
